// === packages
import React from "react";
// === components
import Body from './../components/sections/body'


function NoSuchPage (props){
    return (
        <Body>
            no such page.
        </Body>
    )
}

export default NoSuchPage;